var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"confetti"},_vm._l((_vm.confettiCount),function(n){return _c('div',{key:n,staticClass:"confetti__item",style:(_vm.getConfettiStyle())})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }